import { getCurrentDate } from "../../cpcoc/currentDate";
import { refreshContent } from "./refreshContent";
import { setPageDate } from "./setPageDate";
import { updateURL } from "./updateURL";
const dates = {};
export function getActiveDate() {
    return dates.active;
}
export function getPreviousDate() {
    return dates.previous;
}
export function getDates() {
    return dates;
}
export function setDates(newDate, options) {
    if (dates.active === newDate) {
        // already the same date, so return it and move on
        return dates;
    }
    const ignoreRefresh = options === null || options === void 0 ? void 0 : options.ignoreRefresh;
    // TODO: When we set this, shouldn't we set the previous date?
    dates.active = new Date(newDate);
    setPageDate("previous", -1);
    setPageDate("next", 1);
    // TODO: see setTypes might could use a seperate function?
    if (!ignoreRefresh) {
        refreshContent();
        updateURL();
    }
    console.log(`today is set to ${getCurrentDate().toLocaleDateString()}, and looking at ${dates.active.toLocaleDateString()}`);
    return dates;
}
